import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import Loader from '../../components/loader';

function App() {

    const userID = sessionStorage.getItem("TRCUserId");
    const userEmail = sessionStorage.getItem("TRCUserEmail");
    const userName = sessionStorage.getItem("TRCUserName");
    const userPosition = sessionStorage.getItem("TRCUserPosition");

    const [routeData, setRouteData] = useState('');
    const [inputData, setinputData] = useState({ zones: "", routeId: "", productId: "", price: "", group: "" });
    const [zoneData, setZoneData] = useState('');
    const [routeFilter, setRouteFilter] = useState('');
    const [productData, setData] = useState(null);
    const [dealerData, setDealerData] = useState([]);
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [loading, setLoading] = useState(false);
    const [live, setLive] = useState('route');
    const [searchTerm, setSearchTerm] = useState('');
    const [groups, setGroups] = useState([]);

    const getData = async () => {
        setLoading(true);  
        try {
            const zones = await axios.get('https://api.trucoo.in/zone/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            if(zones.data.status === 'success'){
                setZoneData(zones.data.data);
            }
            const routes = await axios.post('https://api.trucoo.in/routes/view/',{}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            if(routes.data.status === 'success'){
                setRouteData(routes.data.routes);
            }

            const  product = await axios.get('https://api.trucoo.in/product/allproduct/');
            if(product.data.status === 'success'){
                setData(product.data.data);
            }

            const dealer = await axios.get('https://api.trucoo.in/dealers/view/',{
			  headers: {
				'Content-Type': 'application/json',
				'X-API-KEY': 'erpTrucoo',
			  },
			});
            if(dealer.data.status === 'success'){
                setDealerData(dealer.data.data);
            }

        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
        setLoading(false);  
    };

    const getGroups = () => {
        let groups = [];

        dealerData?.forEach(dealer => {
            const group = dealer?.group;

            if (group && !groups.includes(group)) {
            groups.push(group);
            }
        });

        setGroups(groups);
    };


    useEffect(() => {
        getData();
    },[userID]);

    useEffect(() => {
        getGroups();
    },[dealerData]);

    useEffect(() => {
        setSelectedDealer([]);
    },[live]);

    useEffect(()=> {
        const filterDealer = dealerData.filter(dealer => dealer.routeId === inputData.routeId);
        const dealerIds = filterDealer.map(d => ({
            dealerId: d?.id
        }));
        setSelectedDealer(dealerIds);
    },[inputData?.routeId]);

    useEffect(()=> {
        const filterDealer = dealerData.filter(dealer => dealer.group === inputData.group);
        const dealerIds = filterDealer.map(d => ({
            dealerId: d?.id
        }));
        setSelectedDealer(dealerIds);
    },[inputData?.group]);

    const newData = (e) => {
        const { name, value } = e.target;
        setinputData((prevData) => ({
          ...prevData,
          [name]: value,
          ['userId']: userID
        }));
    };

    const filedsCheck = () => {

        if(live === 'route'){
            if(!inputData?.routeId || !inputData?.productId || !inputData?.price || !selectedDealer){
                return false;
            }
        }else if(live === 'dealer'){
            if( !inputData?.productId || !inputData?.price || !selectedDealer){
                return false;
            }
        }else{
            if( !inputData?.group || !inputData?.price || !selectedDealer){
                return false;
            }
        }

        return true;
    };

    const saveChanges = async() => {
        setLoading(true);  
        if(!filedsCheck()){
            alert('All fields required!');
            setLoading(false);
            return;
        }
        const sendData = {
            dealers: selectedDealer,
            price: inputData.price,
            item: inputData.productId
        }

        try {
            const response = await axios.post('https://api.trucoo.in/routes/price/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
          
            if(response.data.status === 'success'){
                setinputData({ zones: "", routeId: "", productId: "", price: "", group: "" });
                getData();
                alert(response.data.status);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
        setLoading(false);  
    };


    const routeFilterData = (e) => {
        const { name, value } = e.target;
        setinputData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        if(value !== ''){
            const filteredRoutes = routeData.filter(route => route.zoneId === value);
            setRouteFilter(filteredRoutes);
        } else {
            getData();
        }
    };

    const filteredOptions = dealerData
        ?.filter(option =>
            option.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            option.dealer?.toLowerCase().includes(searchTerm.toLowerCase())
        )
        ?.sort(
            (a, b) =>
            selectedDealer.some(d => d.dealerId === b.id) -
            selectedDealer.some(d => d.dealerId === a.id)
        );

    const handleSelect = (option) => {
        setSelectedDealer(prev =>
            prev.some(d => d.dealerId === option)
            ? prev.filter(d => d.dealerId !== option)
            : [...prev, { dealerId: option }]
        );
    };

return(
<>
    {loading && <Loader />}
    <Header />
    <Sidebar />

    <div class="content-wrapper">
        <div class="container-full">
        
            <section class="content">
            <div class="box">
                <div class="box-header with-border">
                  <h4 class="box-title">Product Pricing</h4>
                  <p class="mb-0 box-subtitle">Routes wise price update</p>
                  <div style={{float: 'right', marginTop: '-40px'}}>
                    <div className='input-group'>
                        <button className={`btn ${live === 'route'  ? 'btn-primary' : 'btn-secondary'}`} onClick={()=> setLive('route')}>Route Wise</button>
                        <button className={`btn ${live === 'dealer' ? 'btn-primary' : 'btn-secondary'}`} onClick={()=> setLive('dealer')}>Dealer Wise</button>
                        <button className={`btn ${live === 'group'  ? 'btn-primary' : 'btn-secondary'}`} onClick={()=> setLive('group')}>Group Wise</button>
                    </div>
                  </div>
                </div>
                <div class="box-body" style={{minHeight: '66vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    
                    {live === 'route' ?
                        <div class="row" style={{border: '1px solid #333', padding: '50px', borderRadius: '20px'}}>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="form-label">Select Zone</label>
                                    <select class="form-select" name="zones" value={inputData?.zones} onChange={(e)=>routeFilterData(e)} >
                                        <option value="" hidden>Select a Zone</option>
                                        {zoneData && zoneData?.map(data=>
                                            <option value={data.id}>{data.zone}</option>
                                        )}
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="form-label">Select Route</label>
                                    <select class="form-select" name="routeId" value={inputData?.routeId} onChange={(e)=>newData(e)} >
                                        <option value="" hidden>Select a Route</option>
                                        {routeFilter && routeFilter?.map(data=>
                                            <option value={data.id}>{data.route}</option>
                                        )}
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="form-label">Select Product</label>
                                    <select class="form-select" name="productId" value={inputData?.productId} onChange={(e)=>newData(e)} >
                                        <option value="" hidden>Select a Product</option>
                                        {productData && productData?.map(data=>
                                            <option value={data.id}>{data.productCode} - {data.productName}</option>
                                        )}
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="form-label">Price</label>
                                    <input type="text" class="form-control" name="price" placeholder='Enter Price...' value={inputData?.price} onChange={(e)=>newData(e)} required />
                                </div>
                            </div>
                            <div class="col-md-12 mt-2" align="center">
                                <div class="form-group">
                                    <button class="btn btn-success mt-4" onClick={saveChanges}> Update</button>
                                </div>
                            </div>

                        </div>

                    : live === 'dealer' ?
                        
                        <div class="row" style={{border: '1px solid #333', padding: '20px', borderRadius: '20px'}}>
                            <div class="col-md-4">
                                <div class="form-group">
									<label class="form-label">Select Dealer</label>
									<div className="select-container">

        								<div className="dropdown" style={{ maxHeight: '500px', overflowY: 'auto', marginTop: '5px', border: '1px solid #333', padding: '5px', borderRadius: '10px' }}>
          									<input type="text" className="form-control mt-2" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ padding: '5px', width: '100%', border: '1px solid #6c6c6c' }} />
          									<div className="options" style={{ maxHeight: '280px', overflowY: 'auto' }}>
            									{filteredOptions.length === 0 ? (
              										<div className="no-options">No matching options</div>
            									) : (
              										filteredOptions.map((option, index) => (
                										<button key={index} className={selectedDealer?.some(d => d.dealerId === option.id) ? 'form-control mt-2 bg-primary' : 'form-control mt-2'} onClick={() => handleSelect(option.id)} >
                  											{option.dealer} 
                										</button>
              										))
            									)}
          									</div>
        								</div>
    								</div>
								</div>
                            </div>

                            <div class="col-md-8" style={{minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label class="form-label">Select Product</label>
                                            <select class="form-select" name="productId" value={inputData?.productId} onChange={(e)=>newData(e)} >
                                                <option value="" hidden>Select a Product</option>
                                                {productData && productData?.map(data=>
                                                    <option value={data.id}>{data.productCode} - {data.productName}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label class="form-label">Price</label>
                                            <input type="text" class="form-control" name="price" placeholder='Enter Price...' value={inputData?.price} onChange={(e)=>newData(e)} required />
                                        </div>
                                    </div>
                                    <div class="col-md-2 mt-2" align="center">
                                        <div class="form-group">
                                            <button class="btn btn-sm btn-success mt-4" onClick={saveChanges}> Update</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    
                    :
                        <div class="row" style={{border: '1px solid #333', padding: '50px', borderRadius: '20px'}}>
                            
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-label">Select Group</label>
                                    <select class="form-select" name="group" value={inputData?.group} onChange={(e)=>newData(e)} >
                                        <option value="" hidden>Select a Group</option>
                                        {groups?.map((group, index) => (
                                            <option key={index} value={group}>
                                            {group}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-label">Select Product</label>
                                    <select class="form-select" name="productId" value={inputData?.productId} onChange={(e)=>newData(e)} >
                                        <option value="" hidden>Select a Product</option>
                                        {productData && productData?.map(data=>
                                            <option value={data.id}>{data.productCode} - {data.productName}</option>
                                        )}
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-label">Price</label>
                                    <input type="text" class="form-control" name="price" placeholder='Enter Price...' value={inputData?.price} onChange={(e)=>newData(e)} required />
                                </div>
                            </div>
                            <div class="col-md-12 mt-2" align="center">
                                <div class="form-group">
                                    <button class="btn btn-success mt-4" onClick={saveChanges}> Update</button>
                                </div>
                            </div>

                        </div>
                    }

                </div>
              </div>
            </section>
        </div>
    </div>

    <Footer />
</>
);
}

export default App;